// Public
export const getZoomPan = (rectangles, isSmall = false) => {
  if (!rectangles?.length) return { zoom: 1, panX: 0.5, panY: 0.5 }
  const { maxX, minX, maxY, minY } = getXYValues(rectangles)
  const panX = (maxX + minX) / 2
  const panY = (maxY + minY) / 2
  const zoom = calcZoom(maxX, minX, maxY, minY, isSmall)
  return { zoom, panX, panY }
}

export const getPan = (rectangles) => {
  if (!rectangles?.length) return { panX: 0.5, panY: 0.5 }
  const { maxX, minX, maxY, minY } = getXYValues(rectangles)
  const panX = (maxX + minX) / 2
  const panY = (maxY + minY) / 2
  return { panX, panY }
}

export const getZoom = (rectangles, isSmall) => {
  if (!rectangles?.length) return 1
  const { maxX, minX, maxY, minY } = getXYValues(rectangles)
  return calcZoom(maxX, minX, maxY, minY, isSmall)
}

// Private
function calcZoom(maxX, minX, maxY, minY, isSmall = false) {
  const differenceX = maxX - minX
  const differenceY = maxY - minY
  let zoom = 1

  const thresholds = isSmall
    ? [
        { threshold: 0.3, zoom: 2 },
        { threshold: 0.15, zoom: 4 },
        { threshold: 0.08, zoom: 7 },
      ]
    : [
        { threshold: 0.6, zoom: 1 },
        { threshold: 0.4, zoom: 2 },
        { threshold: 0.3, zoom: 3 },
        { threshold: 0.2, zoom: 4 },
        { threshold: 0.1, zoom: 5 },
        { threshold: 0.05, zoom: 6 },
      ]

  thresholds.forEach(({ threshold, zoom: z }) => {
    if (differenceX < threshold && differenceY < threshold) {
      zoom = z
    }
  })

  return zoom
}

function calcMinMax(values) {
  const max = Math.max(...values)
  const min = Math.min(...values)
  return { max, min }
}

function getXYValues(unfilteredRectangles) {
  const rectangles = unfilteredRectangles.filter(Boolean) // This filters out any rectangles that are null
  const { max: maxX, min: minX } = calcMinMax(rectangles.flatMap((rectangle) => [rectangle.x1, rectangle.x2]))
  const { max: maxY, min: minY } = calcMinMax(rectangles.flatMap((rectangle) => [rectangle.y1, rectangle.y2]))
  return { maxX, minX, maxY, minY }
}
